import { render, staticRenderFns } from "./BaseYxVoucher.vue?vue&type=template&id=a043a240&scoped=true"
import script from "./BaseYxVoucher.vue?vue&type=script&lang=js"
export * from "./BaseYxVoucher.vue?vue&type=script&lang=js"
import style0 from "./BaseYxVoucher.vue?vue&type=style&index=0&id=a043a240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a043a240",
  null
  
)

export default component.exports